import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Collapse,
  Avatar,
  AppBar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Toolbar,
  Select,
  MenuItem,
  Button,
  Modal,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { jsPDF } from 'jspdf';
import {
  ExpandMore,
  ExpandLess,
  Notifications,
  CalendarToday,
  Print,
  People,
} from "@mui/icons-material";
import {  VendorappBar } from "../../components";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch } from "../../hooks";
import { useSelector } from "react-redux";

export default function ListingPaymentManagement({onBackScreenName}) {
  const [openRowId, setOpenRowId] = useState(null); // Tracks expanded row
  const [searchText, setSearchText] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("This Month");
    // Invoice Download Modal States
    const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
    const [selectedInvoiceData, setSelectedInvoiceData] = useState(null);

    // Get vendor details from Redux store
    const userDetails = useSelector((state) => state.user.userdetails);
    const loginToken = useSelector((state) => state.user.logintoken);
    const { id } = useSelector((state) => state.user.userdetails);

    // State to store delivered orders data
    const [totalSold, setTotalSold] = useState(0);
    const [totalValue, setTotalValue] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);

    // API call to fetch delivered orders
    const {
      data: deliveredOrdersData,
      isLoading: deliveredOrdersLoading,
      error: deliveredOrdersError,
      fetchData: fetchDeliveredOrders,
    } = useFetch(BASE_URL_TEST + urls("getListingOrders"), {
      method: "POST",
       headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

    // API call to fetch vendor listings
    const {
      data: vendorListingsData,
      isLoading: vendorListingsLoading,
      error: vendorListingsError,
      fetchData: fetchVendorListings,
    } = useFetch(BASE_URL_TEST + urls("getAllVListingById", id), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

    // Fetch delivered orders and vendor listings on component mount
    useEffect(() => {
      if (userDetails && userDetails.vendor_id) {
        fetchDeliveredOrders({
          vendor_id: userDetails.vendor_id,
          order_status: "DELIVERED"
        });
        fetchVendorListings();
      }
    }, [userDetails]);

    // Update state when API data is received
    useEffect(() => {
      if (deliveredOrdersData && deliveredOrdersData.status) {
        setTotalSold(deliveredOrdersData.data.total_orders || 0);
        setTotalValue(deliveredOrdersData.data.total_amount || 0);
      }
    }, [deliveredOrdersData]);

    // Update total users count when vendor listings data is received
    useEffect(() => {
      if (vendorListingsData && vendorListingsData.status && vendorListingsData.data) {
        setTotalUsers(Array.isArray(vendorListingsData.data) ? vendorListingsData.data.length : 0);
      }
    }, [vendorListingsData]);

    const handleInvoiceModalOpen = (orderId, orderItem, orderDetails, orderSummary) => {
      setSelectedInvoiceData({ orderId, orderItem, orderDetails, orderSummary });
      setOpenInvoiceModal(true);
    };
    const handleInvoiceModalClose = () => {
      setOpenInvoiceModal(false);
      setSelectedInvoiceData(null);
    };
  

  // Transform API data into rows format
  const rows = React.useMemo(() => {
    if (!deliveredOrdersData || !deliveredOrdersData.data || !deliveredOrdersData.data.ordersData) {
      return [];
    }

    return deliveredOrdersData.data.ordersData.map((order) => {
      // Format date
      const orderDate = new Date(order.created_at);
      const formattedDate = orderDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\//g, '-');

      // Determine status display
      const status = order.order_status || "Pending";

      return {
        id: order.cart_vendor_id,
        orderNumber: order.cart_number,
        item: order.vendorDetails?.shop_name || "N/A",
        category: "Listing",
        date: formattedDate,
        price: `₹${parseFloat(order.total_amount).toFixed(2)}`,
        paymentType: order.cartDetails?.payment_method || "N/A",
        status: status,
        customerName: `${order.cartDetails?.customerDetails?.first_name || ""} ${order.cartDetails?.customerDetails?.last_name || ""}`.trim() || order.cartDetails?.customerDetails?.phone_number || "N/A",
        customerPhone: order.cartDetails?.customerDetails?.phone_number || "N/A",
        transactionId: order.cartDetails?.transaction_id || "N/A",
        distance: `${order.distance} km`,
        details: [
          {
            sku: order.cart_vendor_id,
            name: order.vendorDetails?.shop_name || "N/A",
            price: `₹${parseFloat(order.total_amount).toFixed(2)}`,
            qty: "x1",
            discount: order.cartDetails?.coupon_discount ? `₹${parseFloat(order.cartDetails.coupon_discount).toFixed(2)}` : "₹0.00",
            total: `₹${parseFloat(order.total_amount).toFixed(2)}`,
          },
        ],
        summary: {
          subtotal: `₹${parseFloat(order.total_amount).toFixed(2)}`,
          shipping: "₹0.00",
          discount: order.cartDetails?.coupon_discount ? `-₹${parseFloat(order.cartDetails.coupon_discount).toFixed(2)}` : "-₹0.00",
          total: `₹${parseFloat(order.total_amount).toFixed(2)}`,
          coupon: order.cartDetails?.coupon || "N/A",
        },
      };
    });
  }, [deliveredOrdersData]);

  const transactions = [
    {
      id: 1,
      requestDate: "27-07-2024",
      time: "10:30AM",
      amount: "5,000",
      bank: "SBI",
      status: "Pending",
      details: {
        transactionId: "T2489756466745575",
        dateTime: "23-07-2024 / 5:30PM",
        bankAccount: "SBI8567468532",
      },
    },
    {
      id: 2,
      requestDate: "22-07-2024",
      time: "10:30AM",
      amount: "5,000",
      bank: "SBI",
      status: "Completed",
      details: {
        transactionId: "T2489756466745576",
        dateTime: "22-07-2024 / 5:30PM",
        bankAccount: "SBI8567468533",
      },
    },
    {
      id: 3,
      requestDate: "22-06-2024",
      time: "10:30AM",
      amount: "5,000",
      bank: "SBI",
      status: "Completed",
      details: {
        transactionId: "T2489756466745577",
        dateTime: "22-06-2024 / 5:30PM",
        bankAccount: "SBI8567468534",
      },
    },
  ];



  const handlePrintInvoice = (orderId, orderItem, orderDetails, orderSummary) => {
    try {
      // Create new PDF document
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.width;

      // Add title
      doc.setFontSize(20);
      doc.text('INVOICE', pageWidth / 2, 20, null, null, 'center');

      // Add company info
      doc.setFontSize(12);
      doc.text('Sthanick Web Services', pageWidth / 2, 35, null, null, 'center');
      doc.text('Payment Invoice', pageWidth / 2, 45, null, null, 'center');

      // Add order details
      doc.setFontSize(12);
      doc.text(`Order ID: #${orderId}`, 20, 65);
      doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, 75);
      doc.text(`Item: ${orderItem}`, 20, 85);

      // Add line separator
      doc.line(20, 95, pageWidth - 20, 95);

      // Add items header
      doc.setFontSize(14);
      doc.text('ITEMS:', 20, 110);

      // Add items table
      let yPosition = 125;
      doc.setFontSize(10);

      orderDetails.forEach((item, index) => {
        doc.text(`${index + 1}. ${item.name}`, 25, yPosition);
        doc.text(`SKU: ${item.sku}`, 30, yPosition + 8);
        doc.text(`Price: ${item.price}`, 30, yPosition + 16);
        doc.text(`Quantity: ${item.qty}`, 120, yPosition + 8);
        doc.text(`Discount: ${item.discount}`, 120, yPosition + 16);
        doc.text(`Total: ${item.total}`, 30, yPosition + 24);
        yPosition += 35;

        // Add item separator
        doc.line(25, yPosition - 3, pageWidth - 25, yPosition - 3);
      });

      // Add summary section
      yPosition += 10;
      doc.setFontSize(12);
      doc.text('PAYMENT SUMMARY:', 20, yPosition);

      yPosition += 15;
      doc.setFontSize(10);
      doc.text('Subtotal:', 25, yPosition);
      doc.text(orderSummary.subtotal, pageWidth - 60, yPosition);

      yPosition += 10;
      doc.text('Shipping:', 25, yPosition);
      doc.text(orderSummary.shipping, pageWidth - 60, yPosition);

      yPosition += 10;
      doc.text('Discount:', 25, yPosition);
      doc.text(orderSummary.discount, pageWidth - 60, yPosition);

      // Add total line
      yPosition += 15;
      doc.line(20, yPosition - 5, pageWidth - 20, yPosition - 5);
      doc.setFontSize(12);
      doc.text('TOTAL:', 25, yPosition);
      doc.text(orderSummary.total, pageWidth - 60, yPosition);

      // Add footer
      yPosition += 30;
      doc.setFontSize(8);
      doc.text('Thank you for your business!', pageWidth / 2, yPosition, null, null, 'center');

      // Save the PDF
      doc.save(`Invoice_${orderId}_${new Date().toISOString().split('T')[0]}.pdf`);

    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    }
  };

  const handleRowToggle = (id) => {
    setOpenRowId(openRowId === id ? null : id);
  };
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* AppBar */}
        {/* <AppBar
          position="static"
          elevation={0}
          sx={{
            borderBottom: "1px solid #ddd",
            mb: 2,
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px",
          }}
        >
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Payment Management
            </Typography>

            <IconButton>
              <CalendarToday />
            </IconButton>
            <Typography variant="body1" sx={{ mx: 2 }}>
              28 Dec, 2024
            </Typography>
            <IconButton>
              <Notifications />
            </IconButton>
            <Avatar alt="Gn" src="/profile.webp" />
          </Toolbar>
        </AppBar> */}
        <VendorappBar title={"Payment Management"} onBackScreenName={handleScreeName} />

        {/* Statistics Cards Section */}
        <Box p={2}>
        <Box display="flex" justifyContent="space-around" alignItems="center" mb={3} gap={2}>
          {/* Total Units Sold Card */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            borderRadius={4}
            boxShadow={3}
            p={2.5}
            bgcolor="white"
            flex={1}
            sx={{
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 5
              }
            }}
          >
            <Box display="flex" alignItems="center" width="100%">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                borderRadius="50%"
                bgcolor="#E3F2FD"
                p={1.5}
              >
                <ShoppingCartOutlinedIcon style={{ fontSize: 28, color: '#2196F3' }} />
              </Box>
              <Box ml={2}>
                <Typography variant="subtitle2" color="textSecondary">
                  Total Units Sold
                </Typography>
                <Typography variant="h5" fontWeight="bold" color="#2196F3">
                  {deliveredOrdersLoading ? "..." : totalSold}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Total Revenue Card */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            borderRadius={4}
            boxShadow={3}
            p={2.5}
            bgcolor="white"
            flex={1}
            sx={{
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 5
              }
            }}
          >
            <Box display="flex" alignItems="center" width="100%">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                borderRadius="50%"
                bgcolor="#E8F5E9"
                p={1.5}
              >
                <AttachMoneyOutlinedIcon style={{ fontSize: 28, color: '#4CAF50' }} />
              </Box>
              <Box ml={2}>
                <Typography variant="subtitle2" color="textSecondary">
                  Total Revenue
                </Typography>
                <Typography variant="h5" fontWeight="bold" color="#4CAF50">
                  {deliveredOrdersLoading ? "..." : `₹${totalValue.toLocaleString('en-IN')}`}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Total User List Card */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            borderRadius={4}
            boxShadow={3}
            p={2.5}
            bgcolor="white"
            flex={1}
            sx={{
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 5
              }
            }}
          >
            <Box display="flex" alignItems="center" width="100%">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                borderRadius="50%"
                bgcolor="#FFF3E0"
                p={1.5}
              >
                <People style={{ fontSize: 28, color: '#FF9800' }} />
              </Box>
              <Box ml={2}>
                <Typography variant="subtitle2" color="textSecondary">
                  Total User List
                </Typography>
                <Typography variant="h5" fontWeight="bold" color="#FF9800">
                  {vendorListingsLoading ? "..." : totalUsers}
                </Typography>
              </Box>
            </Box>
          </Box>

        </Box>

        {/* Order Payment History Section */}
        <Box mb={4}>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Order Payment History
          </Typography>
          {/* Search Bar and Filter */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search by order number or ID"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <Select
              size="small"
              defaultValue="recent"
              variant="outlined"
              style={{ width: 200 }}
            >
              <MenuItem value="recent">Recent transactions</MenuItem>
              <MenuItem value="older">Older transactions</MenuItem>
            </Select>
          </Box>

          {/* Table */}
          <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{fontWeight:"bold"}}>ORDER NUMBER</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>VENDOR</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>CATEGORY</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>DATE</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>AMOUNT</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>PAYMENT METHOD</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>STATUS</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {deliveredOrdersLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography>Loading orders...</Typography>
                    </TableCell>
                  </TableRow>
                ) : rows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography>No orders found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  rows
                    .filter((row) =>
                      row.orderNumber.toLowerCase().includes(searchText.toLowerCase()) ||
                      row.id.toString().includes(searchText)
                    )
                    .map((row) => (
                    <React.Fragment key={row.id}>
                      <TableRow>
                        <TableCell>{row.orderNumber}</TableCell>
                        <TableCell>{row.item}</TableCell>
                        <TableCell>{row.category}</TableCell>
                        <TableCell>{row.date}</TableCell>
                        <TableCell>{row.price}</TableCell>
                        <TableCell>{row.paymentType}</TableCell>
                        <TableCell >
                          <Typography
                          sx={{fontWeight:"bold"}}
                            color={
                              row.status === "Delivered" || row.status === "Completed"
                                ? "green"
                                : row.status === "Pending"
                                ? "orange"
                                : "red"

                            }
                          >
                            {row.status}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={() => handleRowToggle(row.id)}>
                            {openRowId === row.id ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      {/* Collapsible Row */}
                      <TableRow>
                        <TableCell style={{ padding: 0 }} colSpan={8}>
                          <Collapse
                            in={openRowId === row.id}
                            timeout="auto"
                            unmountOnExit
                          >
                            {row.details.length > 0 ? (
                              <Box margin={2}>
                                {/* Customer Information */}
                                <Box mb={2} p={2} bgcolor="#f5f5f5" borderRadius={2}>
                                  <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                                    Customer Information:
                                  </Typography>
                                  <Box display="flex" gap={3}>
                                    <Typography variant="body2">
                                      <strong>Name:</strong> {row.customerName}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Phone:</strong> {row.customerPhone}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Transaction ID:</strong> {row.transactionId}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Distance:</strong> {row.distance}
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* Order Details Table */}
                                <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                                  Order Details:
                                </Typography>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        ORDER ID
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        VENDOR NAME
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        AMOUNT
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        QTY
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        DISCOUNT
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        TOTAL
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        PRINT
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {row.details.map((detail) => (
                                      <TableRow key={detail.sku}>
                                        <TableCell>{detail.sku}</TableCell>
                                        <TableCell>{detail.name}</TableCell>
                                        <TableCell>{detail.price}</TableCell>
                                        <TableCell>{detail.qty}</TableCell>
                                        <TableCell
                                          sx={{
                                            color: "red",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {detail.discount}
                                        </TableCell>
                                        <TableCell>{detail.total}</TableCell>
                                        <TableCell>
                                          <IconButton
                                            onClick={() => handleInvoiceModalOpen(row.id, row.item, row.details, row.summary)}
                                            sx={{
                                              color: "#3f51b5",
                                              "&:hover": {
                                                backgroundColor: "rgba(63, 81, 181, 0.1)",
                                              },
                                            }}
                                          >
                                            <Print />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>

                                {/* Payment Summary */}
                                <Box mt={2} p={2} bgcolor="#f5f5f5" borderRadius={2}>
                                  <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                                    Payment Summary:
                                  </Typography>
                                  <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2">Subtotal:</Typography>
                                    <Typography variant="body2" fontWeight="bold">
                                      {row.summary.subtotal}
                                    </Typography>
                                  </Box>
                                  <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2">Shipping:</Typography>
                                    <Typography variant="body2" fontWeight="bold">
                                      {row.summary.shipping}
                                    </Typography>
                                  </Box>
                                  <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2">Discount:</Typography>
                                    <Typography variant="body2" fontWeight="bold" color="red">
                                      {row.summary.discount}
                                    </Typography>
                                  </Box>
                                  {row.summary.coupon !== "N/A" && (
                                    <Box display="flex" justifyContent="space-between" mb={1}>
                                      <Typography variant="body2">Coupon:</Typography>
                                      <Typography variant="body2" fontWeight="bold">
                                        {row.summary.coupon}
                                      </Typography>
                                    </Box>
                                  )}
                                  <Box display="flex" justifyContent="space-between" mt={2} pt={2} borderTop="2px solid #ddd">
                                    <Typography variant="subtitle1" fontWeight="bold">Total:</Typography>
                                    <Typography variant="subtitle1" fontWeight="bold" color="primary">
                                      {row.summary.total}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            ) : (
                              <Box margin={2}>
                                <Typography>No details available.</Typography>
                              </Box>
                            )}
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Vendor Payment History Section */}
      
      </Box>

      {/* Invoice Download Modal */}
      <Modal open={openInvoiceModal} onClose={handleInvoiceModalClose}>
        <Box
          p={4}
          bgcolor="white"
          borderRadius={2}
          boxShadow={24}
          sx={{
            width: { xs: "calc(100vw - 24px)", sm: 650 },
            maxWidth: "100%",
            maxHeight: "80vh",
            margin: "auto",
            marginTop: "2%",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Typography variant="h6" mb={2} textAlign="center" fontWeight="bold">
            Invoice Details
          </Typography>

          {selectedInvoiceData && (
            <Box sx={{ flexGrow: 1, overflowY: "auto", mb: 2 }}>
              {/* Order Information */}
              <Box mb={3} p={2} bgcolor="#f5f5f5" borderRadius={2}>
                <Typography variant="body1" mb={1}>
                  <strong>Order ID:</strong> #{selectedInvoiceData.orderId}
                </Typography>
                <Typography variant="body1" mb={1}>
                  <strong>Item:</strong> {selectedInvoiceData.orderItem}
                </Typography>
                <Typography variant="body1" mb={1}>
                  <strong>Date:</strong> {new Date().toLocaleDateString()}
                </Typography>
              </Box>

              {/* Items Details */}
              <Box mb={3}>
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                  Order Items
                </Typography>
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>SKU</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>NAME</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>PRICE</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>QTY</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>DISC.</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>TOTAL</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedInvoiceData.orderDetails.map((item) => (
                        <TableRow key={item.sku}>
                          <TableCell>{item.sku}</TableCell>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>{item.price}</TableCell>
                          <TableCell>{item.qty}</TableCell>
                          <TableCell sx={{ color: "red", fontWeight: "bold" }}>
                            {item.discount}
                          </TableCell>
                          <TableCell>{item.total}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Payment Summary */}
              <Box p={2} bgcolor="#f5f5f5" borderRadius={2}>
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                  Payment Summary
                </Typography>
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography variant="body2">Subtotal:</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {selectedInvoiceData.orderSummary.subtotal}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography variant="body2">Shipping:</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {selectedInvoiceData.orderSummary.shipping}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography variant="body2">Discount:</Typography>
                  <Typography variant="body2" fontWeight="bold" color="red">
                    {selectedInvoiceData.orderSummary.discount}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" mt={2} pt={2} borderTop="2px solid #ddd">
                  <Typography variant="h6" fontWeight="bold">Total:</Typography>
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    {selectedInvoiceData.orderSummary.total}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}

          {/* Buttons Fixed at Bottom */}
          <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
            <Button
              variant="contained"
              onClick={() => {
                if (selectedInvoiceData) {
                  handlePrintInvoice(
                    selectedInvoiceData.orderId,
                    selectedInvoiceData.orderItem,
                    selectedInvoiceData.orderDetails,
                    selectedInvoiceData.orderSummary
                  );
                  handleInvoiceModalClose();
                }
              }}
              fullWidth
              style={{
                marginBottom: 12,
                backgroundColor: "#00796b",
                color: "white",
                textTransform: "none"
              }}
            >
              Download Invoice
            </Button>
            <Button
              variant="text"
              color="primary"
              onClick={handleInvoiceModalClose}
              style={{ textTransform: "none" }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      </Box>

    </Box>
  );
}
